<template>
  <div v-if="navTree.length" class="side-wp" :class="{close: isClose}">
    <div v-if="isWap && !isClose" class="mask-wp" @click="closeSide"></div>
    <resize-panel
      class="side-nav"
      :class="{ close: !isExpand }"
      :maxWidthRateOfWindow=".3"
      :minWidth="100"
      @sizeChange="sizeChange"
    >
      <div>
        <div class="side-txt">目录</div>
        <div class="side-cont">
          <customMenu ref="menuItem" v-for="(menu, index) in navTree" :key="index" :menuData="menu" @clickAction="itemClick"></customMenu>
        </div>
        <div v-if="!isWap" class="close-box" @click="switchClick">
          <t-icon name="chevron-right" />
        </div>
        <div v-if="isWap" class="btn-close" @click="closeSide"><t-icon name="arrow-right" size="30"/></div>
      </div>
    </resize-panel>
    <div v-if="isWap && isClose" class="btn-scale" @click="openSide"><t-icon name="view-list" size="30"/></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import CustomMenu from '@/components/custom-menu';
import ResizePanel from '@/components/resize-panel';

export default {
  name: 'rightSideNav',
  components: {
    CustomMenu,
    ResizePanel
  },
  inject: ['getIsWap'],
  props: {
    doc: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      anchorList: [],
      navTree: [],
      offsetTopList: [],
      isExpand: true,
      isDomReady: false,
      isOpen: false,
    };
  },
  computed: {
    isWap() {
      return this.getIsWap();
    },
    isClose() {
      return this.isWap && !this.isOpen;
    },
  },
  created() {
    this.initDir();
    this.scrollHandler();
    window.onscroll = this.scrollHandler;
    window.onresize = this.resetDomStatus;
    this.$emit('setBarStatus', this.navTree.length);
  },
  methods: {
    ...mapMutations('sideNav', ['setCurAnchor']),
    initDir() {
      const domList = this.doc.match(/<h[1-6]{1}[^>]*>([\s\S]*?)<\/h[1-6]{1}>/g) || [];
      let preDir;
      domList.forEach((hDom, index) => {
        const startIndex = hDom.indexOf('id="');
        const endIndex = hDom.indexOf('">');
        // 没有id，直接返回
        if (startIndex === -1 || endIndex === -1) return;
        const currentDir = this.getCurrentDir(hDom, index);
        // 设置h标签的父指针
        currentDir.pid = this.getAnchorPid(currentDir, preDir);
        preDir = currentDir;
        this.anchorList.push(currentDir);
      });
      this.fillAnchorChildren();
      this.navTree = this.anchorList.filter((i) => i.pid === 0);
    },
    // 根据h标签获取节点数据
    getCurrentDir(hDom, index) {
      const domId = hDom?.match(/id="([^"]+)"/)?.[1];
      const reg = /<h([1-6]{1})[^>]*>([\s\S]*?)<\/h[1-6]{1}>/;
      const hLevel = Number(hDom.replace(reg, '$1'));
      const titleContent = hDom.replace(reg, '$2');
      // 有可能匹配到的是这样
      //’我<strong>是</strong>h1<em>斜体</em>介绍‘
      //里面还有标签（直接去掉标签）
      const title = titleContent.replaceAll(/<([\s\S]*?)>|<\/([\s\S]*?)>/g, '');
      return {
        id: index + 1, //用于点击的时候选中态
        title,
        domId,
        hLevel,
      };
    },
    // 获取锚点的父指针
    getAnchorPid(currentDir, preDir) {
      let pid = 0;
      if (preDir) {
        if (currentDir.hLevel > preDir.hLevel) {
          pid = preDir.id;
        } else if (currentDir.hLevel === preDir.hLevel) {
          pid = preDir.pid;
        } else {
          const sameDir = [...this.anchorList].reverse().find((item) => item.hLevel === currentDir.hLevel);
          pid = sameDir ? sameDir.pid : 0;
        }
      }
      return pid;
    },
    // 填充锚点子孙
    fillAnchorChildren() {
      this.anchorList.forEach((item) => {
        if (item.pid !== 0) {
          const findParent = this.anchorList.find((i) => i.id === item.pid);
          if (findParent) {
            if (!Array.isArray(findParent.children)) {
              findParent.children = [];
            }
            findParent.children.push(item);
          }
        }
      });
    },
    scrollHandler() {
      if (!this.anchorList.length) return;
      if (!this.isDomReady) {
        let isReady = true;
        // 这里记录每个h标签距离顶部的距离，用于锚点定位
        this.anchorList.forEach((anchor, index) => {
          const dom = document.getElementById(anchor.domId);
          if (dom) {
            if (this.offsetTopList[index] !== dom.offsetTop) {
              isReady = false;
              this.offsetTopList[index] = dom.offsetTop;
            }
          }
        });
        this.isDomReady = isReady;
      }
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const curAnchorIdx = Math.max(
        this.offsetTopList.findIndex((item) => item - 80 >= scrollTop),
        0,
      ); // 80是页面顶部距离
      this.setCurAnchor(this.anchorList[curAnchorIdx].domId);
    },
    switchClick() {
      this.isExpand = !this.isExpand;
      this.$emit('setBarStatus', this.isExpand);
      this.resetDomStatus();
    },
    resetDomStatus() {
      this.isDomReady = false;
    },
    sizeChange({sideWidth}) {
      document.documentElement.style.setProperty('--right-side-width', `${sideWidth}px`);
      setTimeout(() => {
        this.resetDomStatus();
      }, 300);
    },
    openSide() {
      this.isOpen = true;
    },
    closeSide() {
      this.isOpen = false;
    },
    itemClick() {
      this.closeSide();
    }
  },
};
</script>
<style scoped>
.side-nav {
  position: fixed;
  top: 60px;
  right: 0;
  z-index: 10;
  background-color: #fff;
  height: calc(100vh - 60px);
  transition: transform 0.3s;
}
.side-nav.close {
  transform: translateX(var(--right-side-width));
}
.side-nav .side-txt {
  font-size: 16px;
  font-weight: 700;
  color: #202328;
  line-height: 40px;
  padding-left: 20px;
}
.side-cont {
  padding: 0 14px;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: calc(100vh - 100px);
}
.side-nav .close-box {
  position: absolute;
  top: 50%;
  width: 20px;
  height: 80px;
  background-color: #e5e7e9;
  left: -20px;
  margin-top: -40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
}
.side-nav:hover .close-box,
.side-nav.close .close-box {
  opacity: 1;
  pointer-events: initial;
}
.side-nav .close-box::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent #e5e7e9 #e5e7e9 transparent;
}
.side-nav .close-box::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: #e5e7e9 #e5e7e9 transparent transparent;
}
.btn-scale {
  position: fixed;
  z-index: 15;
  width: 30px;
  height: 30px;
  top: 65px;
  right: 5px;
  font-size: 0;
}
.mask-wp {
  position: fixed;
  z-index: 99;
  top: 60px;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  height: calc(100vh - 60px);
}
.btn-close {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>
